import {
	PagedSingleSelectField,
	SingleChangeEvent,
	laravelServiceSelectFetchConfig,
	withOptionsEndpoint,
} from "@dgs/core";
import { FC } from "react";
import { EventTypeOptionResource } from "../types/eventType";

interface Props {
	name: string;
	label: string;
	onChange?: (e: SingleChangeEvent<EventTypeOptionResource>) => void;
	required?: boolean;
	disabled?: boolean;
}

const service = withOptionsEndpoint<EventTypeOptionResource>(["event-types"]);
const fetchConfig = laravelServiceSelectFetchConfig(service);

export const EventTypeSingleSelectField: FC<Props> = ({ name, label, onChange, required, disabled }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			fetchConfig={fetchConfig}
			clearable={true}
			required={required}
			disabled={disabled}
			onChange={onChange}
			compare={(first, second) => first.id === second.id}
		/>
	);
};
